import {fetchProduct} from '../../services/product-service/fetchProduct';
import {RootStore} from '../RootStore';
import {StateInitialData} from '../RootStoreState';

export const fetchServerRenderingSafeData = async (
  rootStore: RootStore,
  slug: string,
): Promise<Pick<
  StateInitialData,
  'product' | 'absoluteProductUrl' | 'isCollectingBackInStockRequests' | 'storeSettings' | 'siteStructure'
> | null> => {
  const [product, {isCollectingRequests: isCollectingBackInStockRequests}, storeSettings, siteStructure] =
    await Promise.all([
      // TODO:Zeev: fetchProduct &  fetchBackInStockSettings are both gql calls that can be merged into one call
      fetchProduct(rootStore, slug),
      rootStore.ecomPublicApi.backInStock.fetchBackInStockSettings(),
      rootStore.ecomPublicApi.settings.getSettings(),
      rootStore.wixCodeApi.site.getSiteStructure({includePageId: true}),
    ]);

  if (!product) {
    return null;
  }

  const absoluteProductUrl = await rootStore.ecomPublicApi.product.getAbsoluteProductUrl({slug: product.urlPart});

  return {
    product,
    absoluteProductUrl,
    isCollectingBackInStockRequests,
    storeSettings,
    siteStructure,
  };
};
